import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import MediaPickerModal from "Main/Modals/MediaModal";

export default class AddGallery extends Component {
  state = {
    title: "",
    img_alt_text: "",
    selectedImage: null,
    showMediaModal: false,

    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  // 🔹 Handle Input
  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // 🔹 Submit
  handleSubmit = async (e) => {
    e.preventDefault();

    const { title, selectedImage, img_alt_text } = this.state;

    if (!title) {
      return this.setState({
        notification: true,
        message: "Title is required",
      });
    }

    if (!selectedImage) {
      return this.setState({
        notification: true,
        message: "Please select an image",
      });
    }

    const payload = {
      title,
      image_id: selectedImage.id,
      img_alt_text,
      role_id: 1,
    };

    try {
      if (init() === "success") {
        this.setState({ loading: true });

        const resp = await axios.post(
          Constants.postUrls.createGallery,
          payload
        );

        this.setState({
          notification: true,
          message: resp.data.message || "Created successfully!",
          loading: false,
        });

        setTimeout(() => {
          this.setState({ redirect: true });
        }, 2000);
      } else {
        window.location.assign("/signin");
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong!",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/gallery" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Add Gallery
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>

                  {/* Title */}
                  <Grid item sm={6}>
                    <TextField
                      label="Title"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  {/* Alt Text */}
                  <Grid item sm={6}>
                    <TextField
                      label="Image Alt Text"
                      name="img_alt_text"
                      value={this.state.img_alt_text}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  {/* Image Picker */}
                  <Grid item sm={12}>
                    <MDButton
                      variant="contained"
                      color="info"
                      onClick={() => this.setState({ showMediaModal: true })}
                    >
                      Select Image
                    </MDButton>

                    {/* Preview */}
                    {this.state.selectedImage && (
                      <img
                        src={
                          Constants.imageDomain +
                          this.state.selectedImage.image_path
                        }
                        style={{
                          width: 100,
                          height: 100,
                          marginTop: 10,
                          borderRadius: 6,
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </Grid>

                </Grid>

                <Grid mt={2}>
                  <MDButton variant="contained" color="info" type="submit">
                    {this.state.loading ? "Creating..." : "Create Gallery"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            {/* Snackbar */}
            <MDSnackbar
              color="success"
              title="Gallery"
              content={this.state.message}
              open={this.state.notification}
            />

            {/* Media Modal */}
            <MediaPickerModal
              visible={this.state.showMediaModal}
              multiple={false}
              onClose={() => this.setState({ showMediaModal: false })}
              onSelect={(images) => {
                this.setState({
                  selectedImage: images[0],
                  showMediaModal: false,
                });
              }}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}